import React, { useState, useEffect } from "react";
import axios from "axios";
import { server, categories, cities } from "../../utills/utils";

import Notification from "./Notification";

import styled from "styled-components";

const NotificationsContainer = styled.div`
  width: 100%;
  height: auto;
`;
const Title = styled.h2`
  margin: 0 0 10px 0;
  padding: 0;
  text-align-left;
  font-weight: 500;
  font-size: 1.3em;
 
`;
function Notifications(props) {
  const [notifications, setNotis] = useState([]);
  const [complete, setComplete] = useState(false);
  const fetchNotifications = async () => {
    try {
      await axios
        .post(server, {
          query: `
                  query{
                    userNotifications(userId:"${props.userId}"){
                      _id
                      userId
                      notificationType
                      shopId
                    }
                  }
                `,
        })
        .then((res) => {
          if (res) {
            setNotis(res.data.data.userNotifications);
            setComplete(true);
          }
          console.log("Notifications", res);
        });
    } catch (error) {
      console.log(error);
      throw error;
    }
  };
  useEffect(() => {
    fetchNotifications();
  }, []);
  return (
    <NotificationsContainer>
      {/* <Title>Notifications</Title> */}
      {props.notifications.map((noti) => {
        return (
          <Notification
            notificationHandler={props.clicked}
            key={noti._id}
            notification={noti}
          />
        );
      })}
    </NotificationsContainer>
  );
}

export default Notifications;
